import { ReactNode } from "react";

// Layout types
export interface ContainerProps {
    children: ReactNode;
    fluid?: boolean;
    className?: string;
}

export const Container = ({ children, fluid = false, className = "" }: ContainerProps) => {
    const containerClass = fluid ? "w-full" : "max-w-[1200px] mx-auto";

    return <div className={`px-6 ${containerClass} ${className}`}>{children}</div>;
};
